<template>
  <v-container>
    <v-row v-if="resultadosPersonal.length == 0" justify="center" align="center" style="min-height: calc(100vh - 120px)">
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="justify-center font-weight-bold ui-module-titlebar">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput v-model="busquedaPersonal.nombre" label="Nombre" />
            <BaseInput v-model="busquedaPersonal.segundoNombre" label="Segundo nombre" />
            <BaseInput v-model="busquedaPersonal.apaterno" label="Apellido paterno" />
            <BaseInput v-model="busquedaPersonal.amaterno" label="Apellido materno" />
            <BaseInput v-model="busquedaPersonal.curp" label="CURP" />
            <BaseInput v-model="busquedaPersonal.CUIP" label="CUIP" />
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton
                    class="ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                  >
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else align="start">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</TextButton>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput label="Filtrar elementos" v-model="filtroPersonal"></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="ui-module-card ui-module-fade-in-up" color="secondary" elevation="8" height="100%">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!hasFoto(personal) || personal.fotoError">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.fotoError = true"
                  />
                </v-col>

                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-caption primary--text">Evaluación C3 vigente hasta</div>
                  <div
                    v-if="personal.examenC3Mes.length > 0 && personal.vigenciaAnio != 0"
                    class="text-subtitle-1 primary--text"
                  >
                    {{ personal.examenC3Mes }} del {{ personal.vigenciaAnio }}
                  </div>
                  <div v-else class="text-subtitle-1 primary--text">Información no registrada</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="secondary darken-1 ui-module-actions">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.REGISTRO_RESULTADOS_C3)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action"
                        elevation="8"
                        :to="{ name: 'adscripcionEnlace', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-account-details</v-icon></v-btn
                      >
                    </template>
                    <span>Registro de resultados C3</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2 ui-module-icon-action"
                        elevation="8"
                        :to="{
                          path: 'expediente_personal/' + personal.idPersonal,
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-account</v-icon></v-btn
                      >
                    </template>
                    <span>Ver expediente</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.TURNAR_C3)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action"
                        elevation="8"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        @click="
                          navegarA(`turna-${personal.idPersonal}`, {
                            name: 'turnaC3',
                            params: { id: personal.idPersonal },
                            query: { from: 'personal' },
                          })
                        "
                        ><v-icon>mdi-check</v-icon></v-btn
                      >
                    </template>
                    <span>Turnar a C3</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <validacion-asuntos-internos-dialog-component
      :active="asuntosInternosDialog"
      :id-personal="selectedPersonal"
      @close="asuntosInternosDialog = false"
    ></validacion-asuntos-internos-dialog-component>
  </v-container>
</template>
<style scoped>
.ui-module-card {
  background: rgba(46, 38, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 165, 2, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  border-color: rgba(255, 165, 2, 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(255, 165, 2, 0.3) !important;
}

::v-deep .v-card-title {
  padding: 16px;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

::v-deep .v-card-text {
  padding: 16px;
}

::v-deep .v-card-actions {
  padding: 12px 16px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

/* Textos negros sobre fondo amarillo-naranja para máximo contraste */
.text-h6.font-weight-bold {
  color: #1a1a1a !important;
}

.primary--text {
  color: #1a1a1a !important;
}

.text-subtitle-1.primary--text {
  color: rgba(26, 26, 26, 0.85) !important;
}

.text-caption.primary--text {
  color: rgba(26, 26, 26, 0.75) !important;
  font-weight: 500 !important;
}

.secondary--text {
  color: #FFA502 !important;
}

::v-deep .v-avatar {
  border: 2px solid rgba(26, 26, 26, 0.4);
  transition: all 0.3s ease;
  background: rgba(46, 38, 22, 0.8) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #1a1a1a;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
}

::v-deep .v-avatar .v-icon {
  color: #FFA502 !important;
  filter: drop-shadow(0 4px 12px rgba(255, 165, 2, 0.6));
}

::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(26, 26, 26, 0.4);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-image {
  border-color: #1a1a1a;
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.primary,
::v-deep .v-card-actions .v-btn {
  background: linear-gradient(135deg, #2e2416 0%, #1a1a0f 100%) !important;
  color: #FFA502 !important;
  border: 2px solid rgba(255, 165, 2, 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .v-btn.primary:hover,
::v-deep .v-card-actions .v-btn:hover {
  background: linear-gradient(135deg, #1a1a0f 0%, #0a0a05 100%) !important;
  border-color: #FFA502 !important;
  color: #ffffff !important;
}

::v-deep .v-btn.secondary,
::v-deep .v-btn[color='secondary'] {
  background: linear-gradient(135deg, #FFA502 0%, #FFD32A 100%) !important;
  color: #1a1a1a !important;
  box-shadow: 0 4px 16px rgba(255, 165, 2, 0.4) !important;
}

::v-deep .v-btn.secondary--text {
  color: #FFA502 !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
  color: #FFA502 !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
  color: #ffffff !important;
}

::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(255, 165, 2, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(255, 165, 2, 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: #FFA502 !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot label {
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .v-input--is-focused .v-text-field__slot label {
  color: #FFA502 !important;
}

::v-deep .v-tooltip__content {
  background: rgba(46, 38, 22, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 165, 2, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 165, 2, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 165, 2, 0.6);
}
</style>
<script>
import _ from 'lodash'
import BaseInput from '@/components/base/BaseInput.vue'
import TextButton from '@/components/base/TextButton.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ValidacionAsuntosInternosDialogComponent from '../../components/enlace/ValidacionAsuntosInternosDialogComponent.vue'

export default {
  components: {
    BaseInput,
    TextButton,
    ValidacionAsuntosInternosDialogComponent,
    TextButton,
  },

  data() {
    return {
      loading: false,
      filtroPersonal: '',
      asuntosInternosDialog: false,
      selectedPersonal: null,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },
    hasFoto(personal) {
      const urlSinFoto =
        'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/frente_AARD930724H214693851.jpg'
      return (
        personal.foto &&
        typeof personal.foto === 'string' &&
        personal.foto.trim() !== '' &&
        personal.foto !== urlSinFoto
      )
    },
    getFullName(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },
    openAsuntosInternosDialog(personal) {
      this.selectedPersonal = personal.idPersonal
      this.asuntosInternosDialog = true
    },

    navegarA(key, route) {
      this.loadingBtn = key
      this.$router.push(route).finally(() => {
        this.loadingBtn = null
      })
    },
  },
}
</script>
